import { executeEvmTransaction } from '../../utils';
export const mayachainSwapper = {
    executeEvmTransaction,
    executeCosmosSdkTransaction: (txToSign, { signAndBroadcastTransaction }) => {
        return signAndBroadcastTransaction(txToSign);
    },
    executeUtxoTransaction: (txToSign, { signAndBroadcastTransaction }) => {
        return signAndBroadcastTransaction(txToSign);
    },
};
